<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline"
        @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6"
            :lg="7"
            :md="8"
            :sm="24">
            <a-form-item label="手机号">
              <a-input ref="phone"
                v-model="inputGroup.phone"
                placeholder="手机号"
                @pressEnter=";(pagination.current = 1), getTableDateNew()">
                <a-icon slot="prefix"
                  type="mobile" />
                <a-tooltip slot="suffix"
                  title="要查询手机号">
                  <a-icon type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)" />
                </a-tooltip>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
            :lg="7"
            :md="8"
            :sm="24">
            <a-form-item label="短信类型">
              <h-one-selec-tag v-model="inputGroup.type"
                placeholder="短信类型"
                dictCode="message_type_code" />
            </a-form-item>
          </a-col>
          <a-col :xl="6"
            :lg="7"
            :md="8"
            :sm="24">
            <a-form-item label="来源">
              <m-ore-select :showType="true"
                showTypeName="name"
                showTypeValue="id"
                v-model="inputGroup.sourceId"
                url="/base/busCommonMessageSourceNew/listAll"
                :asterisk="false"
                :params="{}"
                placeholder="短信来源">
              </m-ore-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
            :lg="7"
            :md="8"
            :sm="24">
            <a-form-item label="模板号">
              <a-input v-model="inputGroup.tempCode"
                placeholder="模板号"
                @pressEnter=";(pagination.current = 1), getTableDateNew()">
                <a-icon slot="prefix"
                  type="pushpin" />
                <a-tooltip slot="suffix"
                  title="根据模板好查询">
                  <a-icon type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45)" />
                </a-tooltip>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
            :lg="7"
            :md="8"
            :sm="24">
            <a-form-item label="结果">
              <h-one-selec-tag v-model="inputGroup.state"
                placeholder="结果"
                dictCode="message_send_state" />
            </a-form-item>
          </a-col>
          <a-col :xl="6"
            :lg="7"
            :md="8"
            :sm="24">
            <a-form-item label="发送平台">
              <h-one-selec-tag v-model="inputGroup.platform"
                placeholder="发送平台"
                dictCode="message_send_platform" />
            </a-form-item>
          </a-col>
          <a-col :xl="6"
            :lg="7"
            :md="8"
            :sm="24">
            <a-form-item label="日期"
              :required="true">
              <a-range-picker @change="getNewDate"
                :default-value="defaultDate"
                class="width-timerpick" />
            </a-form-item>
          </a-col>
          <a-col :xl="24"
            :lg="24"
            :md="24"
            :sm="24">
            <span style="float: right;overflow: hidden;"
              class="table-page-search-submitButtons">
              <a-button class="width-btn"
                type="primary"
                icon="search"
                @click=";(pagination.current = 1), getTableDateNew()">搜索</a-button>
              <a-button type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px">重置</a-button>
              <!-- <a-button class="width-btn"
        type="primary"
        icon="file-excel"
        @click="showExprotSetting = true">导出Excel</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="selectresulttable">
      <a-table :columns="columns"
        :data-source="data"
        :pagination="false"
        :loading="loading"
        bordered
        :scroll="{x:1710}"></a-table>
      <div class="pageBar">
        <a-pagination style="margin-top: 1%; float: right"
          size="small"
          :current="pagination.current"
          :total="pagination.total"
          :show-total="(total, range) => `${range[0]}-${range[1]} 共 ${total} 条`"
          show-size-changer
          show-quick-jumper
          :showSizeChanger="true"
          :pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          @change="onChange"
          @showSizeChange="showSizeChange" />
      </div>
    </div>
    <a-modal v-model="showExprotSetting"
      title="要导出的短信记录"
      @ok="doExportExcel">
      <a-spin :spinning="exproting"
        tip="导出中……">
        <div class="exprotSettingOne">
          <a-row>
            <a-col :span="10"> <span>请选择要导出的时间区间：</span></a-col>
            <a-col :span="14">
              <a-range-picker @change="getNewExprotDate"
                :default-value="exprotDefaultDate" />
            </a-col>
          </a-row>
        </div>
        <div class="exprotSettingTwo">
          <a-row>
            <a-col :span="10"> <span>请选择要导出的模板：</span></a-col>
            <a-col :span="14">
              <a-select show-search
                placeholder="模板号"
                style="width: 100%"
                @select="chooseTemplateCode">
                <a-select-option v-for="(templateItem, index) in templateList"
                  :key="index"
                  :value="templateItem.tempCode">
                  <a-tag color="orange">
                    {{ templateItem.tempCode }}
                  </a-tag>
                  <a-tag color="blue">
                    {{ templateItem.tempName }}
                  </a-tag>
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </div>
        <div class="exprotTemplate">
          <a-row>
            <a-col :span="10"> 模板内容： </a-col>
            <a-col :span="14">
              <a-textarea placeholder="要导出的模板内容"
                :autosize="{ minRows: 3, maxRows: 5 }"
                disabled
                v-model="templateContent" />
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </a-modal>
  </a-card>
</template>


<script>
import { getSmsRecord, getMessageType, getSourcesSelecetOpion, getUserCanReadTemplate } from '@/api/api'
import { downFile, postAction } from '@/api/manage'
import HOneSelecTag from './modules/HOneSelecTag.vue'
import MOreSelect from './modules/NAmeMOreSelect.vue'
import moment from 'moment'
//表格字段名称
const columns = [
  {
    title: '电话',
    dataIndex: 'phone',
    key: 'phone',
    width: 160,
    align: 'center',
  },
  {
    title: '短信内容',
    dataIndex: 'message',
    key: 'message',
    width: 250,
  },
  {
    title: '签名',
    dataIndex: 'signatures',
    key: 'signatures',
    width: 130,
    align: 'center',
  },
  {
    title: '短信类型',
    dataIndex: 'type_dictText',
    key: 'type_dictText',
    width: 120,
    align: 'center',
  },
  {
    title: '来源',
    dataIndex: 'sourceName',
    key: 'sourceName',
    width: 100,
    align: 'center',
  },
  {
    title: '模板号',
    dataIndex: 'tempCode',
    key: 'tempCode',
    width: 80,
    align: 'center',
  },
  {
    title: '模板名',
    dataIndex: 'tempName',
    key: 'tempName',
    width: 100,
    align: 'center',
  },
  {
    title: '平台',
    dataIndex: 'platform_dictText',
    key: 'platform_dictText',
    width: 100,
    align: 'center',
  },
  {
    title: '组id',
    dataIndex: 'groupId',
    key: 'groupId',
    width: 200,
    align: 'center',
  },
  {
    title: '请求结果',
    dataIndex: 'state_dictText',
    key: 'state_dictText',
    width: 150,
    align: 'center',
  },
  {
    title: '状态码',
    dataIndex: 'statusCode',
    key: 'statusCode',
    width: 140,
    align: 'center',
  },
  {
    title: '状态描述',
    dataIndex: 'statusDesc',
    key: 'statusDesc',
    width: 140,
    align: 'center',
  },
  {
    title: '发送时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 120,
  },
]

export default {
  components: { HOneSelecTag, MOreSelect },
  data() {
    return {
      columns,
      data: [],
      //页码数据
      pagination: {
        current: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        pageSize: 10,
      },
      //查询参数
      inputGroup: {
        phone: '',
        type: '',
        sourceId: '',
        tempCode: '',
        state: "",
        platform: "",
      },
      loading: false,
      dateFormat: 'YYYY-MM-DD',
      endDay: '',
      startDay: '',
      exportStartDay: '',
      exportEndDay: '',
      exportTemplateCode: '',
      //日期
      defaultDate: [
        moment(moment(new Date()).subtract(3, 'day').format('YYYY-MM-DD'), this.dateFormat),
        moment(moment(new Date()).format('YYYY-MM-DD'), this.dateFormat),
      ],
      exprotDefaultDate: [
        moment(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'), this.dateFormat),
        moment(moment(new Date()).format('YYYY-MM-DD'), this.dateFormat),
      ],
      showExprotSetting: false,
      exproting: false,
      //用户可见模板列表
      templateList: [],
      templateContent: '',
      url: {
        list: '/base/busCommonMessageSendLogNew/list'
      }
    }
  },
  mounted() {
    //初始化查询日期为近三天
    this.endDay = moment(new Date()).format('YYYY-MM-DD')
    this.startDay = moment(new Date()).subtract(3, 'day').format('YYYY-MM-DD')
    this.exportEndDay = moment(new Date()).format('YYYY-MM-DD')
    this.exportStartDay = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
    //获取列表数据
    this.getTableDateNew()
    //获取导出选项的信息
    this.getUserCanUseTemplate()
  },
  methods: {
    /***
       * 重置
       */
    searchReset() {
      this.inputGroup = {};
      this.pagination.current = 1;
      this.getTableDateNew();
    },
    //页面换页重新获取表格数据
    onChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getTableDateNew()
    },
    //页面容量修改时重新获取表格数据
    showSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getTableDateNew()
    },
    //日期组件
    moment,
    getTableDateNew() {
      const that=this;
      that.loading = true
      let parms = Object.assign({
        startTime: that.startDay,
        endTime: that.endDay,
        pageNo: that.pagination.current,
        pageSize: that.pagination.pageSize,
        userid: that.$ls.get('Login_Userinfo').id,
      }, that.inputGroup);
      postAction(that.url.list, parms).then(res => {
        if (res.success) {
          that.data = res.result.records
          that.pagination.current = res.result.current
          that.pagination.total = res.result.total
        } else {
          that.$message.error('获取数据失败！')
        }
        that.loading = false
      })
    },
    //日期修改后重新获取数据
    getNewDate(dates, dateStrings) {
      this.startDay = dateStrings[0]
      this.endDay = dateStrings[1]
      this.getTableDateNew()
    },
    getNewExprotDate(dates, dateStrings) {
      this.exportStartDay = dateStrings[0]
      this.exportEndDay = dateStrings[1]
    },
    chooseTemplateCode(value) {
      this.exportTemplateCode = value
      this.getContent()
    },
    getUserCanUseTemplate() {
      let queryParams = {
        id: this.$ls.get('Login_Userinfo').id,
      }
      getUserCanReadTemplate(queryParams).then((res) => {
        if (res.success) {
          this.templateList = []
          this.templateList = res.result
          console.log(this.templateList)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getContent() {
      for (var i = 0; i < this.templateList.length; i++) {
        if (this.templateList[i].tempCode == this.exportTemplateCode) {
          this.templateContent = this.templateList[i].contents
          return
        }
      }
    },
    doExportExcel() {
      this.exproting = true
      let parms = {
        templateCode: this.exportTemplateCode,
        endTime: this.exportEndDay,
        startTime: this.exportStartDay,
      }
      let fileName = this.exportStartDay + '到' + this.exportEndDay + '的短信发送记录'
      //使用jeecg封装好的下载js下载xls
      downFile('/goldenHomeMsgMange/exprotSmsRecordExcel', parms).then((data) => {
        console.log(data)
        if (!data) {
          this.$message.warning('文件下载失败')
          this.exproting = false
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
          this.exproting = false
          this.$message.success('导出成功')
          this.showExprotSetting = false
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
          this.exproting = false
          this.$message.success('导出成功')
          this.showExprotSetting = false
        }
      })
    },
  },
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}
.selectresulttable {
  padding: 0.5%;
  background-color: #ffffff;
}
.pageBar {
  width: 100%;
  height: 3rem;
  background-color: #ffffff;
}
.exprotSettingOne {
  height: 100%;
  margin-top: 1%;
}
.exprotSettingTwo {
  height: 100%;
  margin-top: 3%;
}
.exprotTemplate {
  height: 100%;
  margin-top: 3%;
}
.width-timerpick {
  width: 300px !important;
}
.width-btn {
  margin-right: 20px;
}
</style>
